// Le dictionnaire néerlandais de l'interface (issue #137), dans son propre
// fichier pour ne pas tripler la taille d'`i18n.ts`.
//
// TRADUCTION AUTOMATIQUE, PAS ENCORE RELUE. La langue reste hors de
// `LANGUES_OUVERTES` (`lang.ts`) tant qu'un néerlandophone ne l'a pas relue :
// servie à qui la demande (`?lang=nl`), jamais proposée.
//
// Typé `Record<CleUi, string>` : une clé ajoutée au français sans sa
// traduction ici fait échouer la compilation, au lieu d'afficher du français
// au milieu d'un écran néerlandais. Radar vouvoie : « u », jamais « je ».

import type { CleUi } from './i18n'

export const DICT_NL: Record<CleUi, string> = {
  'acces.fin.titre': 'Uw toegang tot Radar is afgelopen.',
  'acces.essai.fin': 'Uw gratis proefperiode eindigt op {date}.',
  'acces.essai.choisir': 'Een formule kiezen',
  'acces.fin.texte': 'Uw vacatures, sollicitaties en cv blijven raadpleegbaar. De nachtelijke opvolging en nieuwe dossiers starten opnieuw met een abonnement.',
  'autreCompte.texte': 'Deze link komt uit de mail van een ander account.',
  'autreCompte.changer': 'Van account wisselen',
  'autreCompte.rester': 'Hier blijven',
  'abonnement.titre': 'Abonnement',
  'abonnement.sAbonner': 'Abonneren',
  'abonnement.redirection': 'Doorsturen naar de betaling…',
  'abonnement.parMois': 'per maand',
  'abonnement.parAn': 'per jaar',
  'abonnement.ttc': 'btw inbegrepen',
  'abonnement.offert': 'Radar wordt u aangeboden.',
  'compteurs.titre': 'Uw gebruik',
  'compteurs.cv': 'Aangepaste cv’s deze week',
  'compteurs.employeurs': 'Gevolgde werkgevers',
  'compteurs.recherches': 'Salaris en gesprek deze maand',
  'compteurs.sur': 'van {max}',
  'compteurs.sansLimite': 'Zonder limiet',
  'compteurs.repart': 'Opnieuw vanaf {date}',
  'compteurs.atteint': 'Bereikt, opnieuw vanaf {date}',
  'compteurs.plein': 'Plafond bereikt',
  'compteurs.avecComplet': 'Met Complet',
  'abonnement.essaiJusqua': 'Gratis proefperiode tot {date}.',
  'abonnement.essaiFini': 'Uw gratis proefperiode is afgelopen op {date}.',
  'abonnement.duree': 'Duur',
  'abonnement.auMois': 'Per maand',
  'abonnement.alAnnee': 'Per jaar',
  'abonnement.radar': 'Radar',
  'abonnement.complet': 'Complet',
  'abonnement.radar.l1': '20 gevolgde werkgevers',
  'abonnement.radar.l2': '15 aangepaste cv’s per week',
  'abonnement.complet.l1': 'Alle werkgevers',
  'abonnement.complet.l2': 'Onbeperkt aangepaste cv’s',
  'abonnement.complet.l3': 'Salaris en gesprek naar believen',
  'abonnement.radar.l3': 'Salaris en gesprek: 2 per maand',
  'abonnement.radar.l4': '4 cv-sjablonen',
  'abonnement.complet.l4': 'Mijn opmaak, uit uw cv gehaald',
  'abonnement.choisir': '{plan} kiezen',
  'abonnement.abonne': 'U bent geabonneerd.',
  'abonnement.abonneJusqua': 'U bent geabonneerd. Volgende vervaldag: {date}.',
  'abonnement.finLe': 'Uw abonnement eindigt op {date}.',
  'abonnement.gerer': 'Kaart, facturen, opzegging',
  'abonnement.reprendre': 'Abonnement hervatten',
  'abonnement.enRetard': 'De laatste betaling is mislukt. Controleer uw kaart.',
  'abonnement.mettreAJour': 'Mijn kaart bijwerken',
  'abonnement.confirmation': 'Betaling ontvangen, bevestiging bezig…',
  'abonnement.confirmationLongue': 'De bevestiging laat op zich wachten. Stripe stuurt ze u per mail; laad deze pagina over enkele minuten opnieuw.',
  'abonnement.annule': 'Betaling geannuleerd. Er is niets veranderd.',
  'abonnement.pasOuvert': 'De betaling is nog niet open.',
  'nav.config': 'Configuratie',
  'lang.toggle.label': 'Taal van de interface',
  'nav.mainAria': 'Hoofdnavigatie',
  'nav.logout': 'Afmelden',
  'nav.accountFallbackRadar': 'Mijn account',
  'nav.accountFallbackConsole': 'Business Manager',
  'nav.consultantsCount': '{n} consultants',
  'login.radar.accroche': 'De vacatures die bij u passen, elke ochtend.',
  'login.modes': 'Aanmelden of een account aanmaken',
  'login.ou': 'of',
  'login.mdp.voir': 'Wachtwoord tonen',
  'login.mdp.masquer': 'Wachtwoord verbergen',
  'inscription.titre': 'Een account aanmaken',
  'inscription.mdp': 'Kies een wachtwoord',
  'inscription.mdpAide': 'Minstens {n} tekens.',
  'inscription.envoyer': 'Mijn account aanmaken',
  'inscription.envoi': 'Versturen…',
  'inscription.essai': 'Een maand gratis, zonder kaart.',
  'inscription.robot': 'Vink de controle tegen robots aan.',
  'inscription.parti.texte': 'Er is net een link verstuurd naar {email}. Open hem om uw account te activeren.',
  'inscription.autreAdresse': 'Een ander adres gebruiken',
  'inscription.activation': 'Uw account wordt geactiveerd…',
  'inscription.lienInvalide': 'Deze link is niet meer geldig. Begin opnieuw met de inschrijving.',
  'login.subtitle.console': 'Consultancyconsole',
  'login.subtitle.admin': 'Beheer',
  'login.subtitle.radar': 'Radar',
  'login.email': 'E-mailadres',
  'login.password': 'Wachtwoord',
  'login.submitting': 'Aanmelden…',
  'login.submit': 'Aanmelden',
  'login.error.generic': 'Aanmelden onmogelijk.',
  'login.oubli.lien': 'Wachtwoord vergeten?',
  'login.google.bouton': 'Doorgaan met Google',
  'login.google.sans_compte': 'Geen account voor dit Google-adres. Toegang is enkel op uitnodiging.',
  'login.google.expire': 'De aanmelding met Google is verlopen. Probeer opnieuw.',
  'login.google.annule': 'Aanmelding met Google geannuleerd.',
  'login.google.erreur': 'Google kon uw identiteit niet bevestigen. Probeer opnieuw.',
  'login.google.ferme': 'De inschrijvingen zijn momenteel gesloten.',
  'login.google.inscription': 'Nog geen account? Google maakt het aan. Een maand gratis, zonder kaart.',
  'login.google.refuse': 'Met dit Google-adres kan geen account aangemaakt worden.',
  'login.oubli.titre': 'Uw adres',
  'login.oubli.envoyer': 'Een aanmeldlink ontvangen',
  'login.oubli.parti': 'Als er een account bestaat voor dit adres, is er net een link vertrokken. Hij is 30 minuten geldig.',
  'accueil.step': 'Stap {n} van {total}',
  'accueil.next': 'Volgende',
  'accueil.back': 'Vorige',
  'accueil.finish': 'Afronden',
  'accueil.done': 'Welkom. Alles staat in “Aan de slag” als u het wilt herlezen.',
  'accueil.radar.title': 'Radar zoekt terwijl u iets anders doet',
  'accueil.radar.lead': 'Sites die elke nacht in uw plaats nagekeken worden.',
  'accueil.radar.body': 'U kiest vacaturesites. Elke nacht leest Radar ze opnieuw, houdt wat nieuw is, vergelijkt elke vacature met uw cv en geeft ze een score. ’s Ochtends hoeft u niet te zoeken: u sorteert wat naar boven kwam.',
  'accueil.radar.body2': 'Een vacature die u interesseert, opent als fiche: de gedetailleerde score, wat overeenkomt, wat ontbreekt, en alles om een aangepast cv en een brief te maken.',
  'accueil.radar.shot1Alt': 'Scherm “Mijn kansen”: een lijst vacatures met hun score',
  'accueil.radar.shot2Alt': 'Fiche van een vacature: gedetailleerde score, sterke punten en tekorten',
  'accueil.extension.title': 'De Chrome-extensie werkt waar u bent',
  'accueil.extension.lead': 'Op LinkedIn, op Indeed, op de site van een werkgever: overal.',
  'accueil.extension.body': 'Ze is optioneel, maar zij helpt u bij de vacatures: als u er een bekijkt, toont ze uw score erop, past ze uw cv aan die vacature aan en schrijft ze een brief. Met één klik stuurt u de vacature ook naar Radar, om er later op terug te komen.',
  'accueil.extension.videoNote': 'Twee minuten, en u ziet precies hoe het eruitziet.',
  'accueil.ensemble.title': 'Twee onafhankelijke tools, beter samen',
  'accueil.ensemble.lead': 'Een die voor u zoekt, een die u volgt wanneer u zoekt.',
  'accueil.ensemble.passifTitle': 'Radar, de modus die vanzelf draait',
  'accueil.ensemble.passifBody': 'Hij leest uw sites elke nacht opnieuw en zet een stapel voor u klaar. U hoeft niets te doen opdat hij werkt.',
  'accueil.ensemble.actifTitle': 'De extensie, de modus van het moment',
  'accueil.ensemble.actifBody': 'Ze werkt op de vacature die u voor ogen hebt, ook op een site die Radar niet opvolgt.',
  'accueil.ensemble.body': 'Als ze met elkaar verbonden zijn, verschijnt er op elke vacature een knop: één klik en ze komt in Radar terecht, met haar score. De vacature die u ’s middags op LinkedIn zag, staat ’s avonds in uw geschiedenis, en u beslist erop te reageren wanneer u tijd hebt.',
  'accueil.ensemble.independants': 'U kunt er ook maar een van de twee gebruiken. Niets hangt van de ander af.',
  'accueil.cv.title': 'Uw cv, één keer',
  'accueil.cv.lead': 'Dat is de referentie waarmee alles vergeleken wordt.',
  'accueil.cv.body': 'Laad het op als pdf. Het wordt één keer gelezen en gestructureerd, en dient daarna om elke vacature te scoren en de aangepaste cv’s te maken. Zonder cv kan er niets vergeleken worden en blijven uw schermen leeg.',
  'accueil.cv.cta': 'Mijn cv opladen',
  'accueil.cv.done': 'Uw cv staat klaar.',
  'accueil.metiers.title': 'Uw beroepen',
  'accueil.metiers.lead': 'Dit zijn de beroepen die we in uw cv gelezen hebben.',
  'accueil.metiers.body': 'Radar beoordeelt voor u enkel de vacatures van deze beroepen. Verwijder wat niet bij u past, voeg toe wat ontbreekt: typ een beroep en kies in de lijst.',
  'accueil.metiers.enCours': 'Uw cv wordt gelezen, enkele seconden…',
  'accueil.metiers.needCv': 'Laad eerst uw cv op in de vorige stap.',
  'accueil.metiers.later': 'U kunt ze altijd wijzigen op uw profielfiche.',
  'accueil.sites.title': 'Kies uw sites',
  'accueil.sites.lead': 'Er is niets aangevinkt: u zegt zelf wat u wilt volgen.',
  'accueil.sites.body': 'Dit zijn de sites die deze Radar al kan lezen. Vink aan wat u aanbelangt: u ziet enkel hun vacatures, en u stoort niemand als u van mening verandert.',
  'accueil.sites.needCv': 'Laad uw cv op in de vorige stap om te kunnen kiezen: de sites worden aan uw profiel gekoppeld.',
  'accueil.sites.offers': '{n} vacatures',
  'accueil.sites.all': 'Alles aanvinken',
  'accueil.sites.none': 'Alles uitvinken',
  'accueil.sites.count': '{n} sites gekozen',
  'accueil.sites.countMax': '{n} / {max} sites gekozen',
  'accueil.sites.plafond': 'Hoogstens {max} sites: vink er een uit om een andere te kiezen.',
  'accueil.sites.later': 'U kunt op elk moment sites toevoegen, verwijderen of nieuwe aanvragen in “Gevolgde sites”.',
  'accueil.revoir': 'De voorstelling opnieuw bekijken',
  'aide.intro': 'Wat Radar is, hoe u de extensie koppelt, en wat niet meteen zal lukken. Deze pagina blijft hier: kom terug wanneer u wilt.',
  'aide.what.title': 'Wat Radar voor u doet',
  'aide.what.body': 'Radar volgt elke nacht in uw plaats vacaturepagina’s op. Elke gevonden vacature wordt met uw cv vergeleken en krijgt een score. U zoekt niet meer: u bekijkt wat naar boven kwam, en u beslist.',
  'aide.what.extension': 'De Chrome-extensie is de andere helft: ze werkt op elke vacaturesite, toont uw score rechtstreeks op de vacature, past uw cv aan en stuurt de vacature met één klik naar Radar. Een vacature die u ’s middags op LinkedIn zag, staat ’s avonds in Radar, met haar score, zonder dat u iets moest noteren.',
  'aide.step.cv.title': '1. Uw cv',
  'aide.step.cv.body': 'Alles begint daar: zonder cv kan er niets vergeleken worden. Laad het op als pdf, het wordt één keer gelezen en gestructureerd. U kunt het op elk moment vervangen.',
  'aide.step.cv.cta': 'Mijn cv opladen of bijwerken',
  'aide.step.install.title': '2. De extensie installeren',
  'aide.step.install.body': 'Gratis, in de Chrome Web Store. Eén klik, niets in te stellen.',
  'aide.step.install.store': 'Toevoegen aan Chrome',
  'aide.step.install.storeS1': 'Klik op de fiche op “Toevoegen aan Chrome” en daarna op “Extensie toevoegen”.',
  'aide.step.install.zipTitre': 'Installeren zonder de Chrome Web Store',
  'aide.step.install.zipQuand': 'Enkel als de store voor u geblokkeerd is, bijvoorbeeld op een computer van uw werkgever.',
  'aide.step.link.autrement': 'Geen knop “Verbinden met Radar”? Meld u aan met uw Radar-adres en -wachtwoord, of met de code hieronder.',
  'accueil2.extension.texte': 'Uw score op elke vacature, LinkedIn inbegrepen: de extensie staat in de Chrome Web Store.',
  'accueil2.extension.plusTard': 'Later',
  'aide.step.install.download': 'De extensie downloaden (versie {version})',
  'aide.step.install.unavailable': 'Het pakket van versie {version} is nog niet klaar. Meld het onderaan deze pagina, u krijgt een bericht zodra het beschikbaar is.',
  'aide.step.install.s1': 'Pak het gedownloade bestand uit in een map die u bewaart: Chrome leest de extensie vanuit die map, de prullenbak zou ze verwijderen.',
  'aide.step.install.s2': 'Open chrome://extensions in een nieuw tabblad en schakel rechtsboven “Ontwikkelaarsmodus” in.',
  'aide.step.install.s3': 'Klik op “Uitgepakte extensie laden” en kies de map “ai-job-fit-{version}” die IN de uitgepakte map staat, niet de uitgepakte map zelf. Antwoordt Chrome “Manifest niet gevonden”, dan ontbreekt dat niveau.',
  'aide.step.install.s4': 'Maak het pictogram vast in de werkbalk: daarmee schakelt u de extensie in op sites die ze nog niet kent.',
  'aide.step.install.sites': 'Ze schakelt zichzelf in op LinkedIn, Indeed en de grote rekruteringstools. Elders vraagt Chrome uw toestemming per site: open de vacature, klik op het pictogram van de extensie en daarna op “Inschakelen op deze site”. Dat is een regel van Chrome, geen beperking van de tool.',
  'aide.step.link.title': '3. De extensie aan Radar koppelen',
  'aide.step.link.body': 'Uw cv komt dan uit Radar: niets te importeren in de extensie, en hier past u het aan.',
  'aide.step.link.lastUsed': 'Extensie verbonden. Laatste verzending: {date}.',
  'aide.step.link.neverUsed': 'Extensie verbonden, maar er is nog geen vacature via haar binnengekomen.',
  'aide.step.link.s1': 'Open de extensie: bij de eerste start opent ze vanzelf. Anders: rechtsklik op het pictogram en daarna “Opties”.',
  'aide.step.link.s2': 'Klik onder het importeren van het cv op “Heb je een Radar-account? Meld je aan” en daarna op “Verbinden met Radar”. Chrome vraagt toegang tot Radar: aanvaard.',
  'aide.step.link.s3': 'Uw cv verschijnt in de extensie, en op elke vacature verschijnt een knop “Bewaren in Radar”.',
  'aide.step.sites.title': '4. Een site toevoegen om op te volgen',
  'aide.step.sites.body': 'Plak het adres van een pagina die vacatures OPSOMT, niet van één enkele vacature. Radar test de extractie voor uw ogen en toont de gevonden titels voor er iets bewaard wordt.',
  'aide.step.sites.warning': 'Goed om vooraf te weten: het lukt niet op alle sites van de eerste keer. Radar herkent de grote platformen zelf; elke andere site vraagt een regel configuratie die met de hand geschreven wordt. In dat geval verschijnt een knop “activering aanvragen”: de aanvraag wordt bewaard, u krijgt een bevestigingsmail en daarna een tweede wanneer de site online is, meestal binnen een week. Dat is geen storing, zo werkt het gewoon.',
  'aide.step.sites.cta': 'Naar mijn opgevolgde sites',
  'aide.shared.title': 'Wat gedeeld wordt en wat niet',
  'aide.shared.body': 'De opgevolgde sites en de verzamelde vacatures zijn GEMEENSCHAPPELIJK voor de accounts van deze Radar: u ziet de sites die anderen toevoegden, en zij zien de uwe. Uw cv, uw scores, uw sollicitaties en uw documenten zijn enkel voor u zichtbaar.',
  'aide.feedback.title': 'Een woordje aan wie Radar ontwikkelt',
  'aide.feedback.body': 'Iets werkt niet, een scherm is verwarrend, er ontbreekt een functie, een site wordt niet ondersteund: schrijf het hier. Het bericht komt rechtstreeks per e-mail aan, met uw adres zodat het antwoord bij u terechtkomt.',
  'aide.feedback.typeLabel': 'Waarover gaat het',
  'aide.feedback.type.bug': 'Iets werkt niet',
  'aide.feedback.type.idea': 'Een idee, een verbetering',
  'aide.feedback.type.site': 'Een site om te ondersteunen',
  'aide.feedback.type.other': 'Iets anders',
  'aide.feedback.messageLabel': 'Uw bericht',
  'aide.feedback.placeholder': 'Wat u deed, wat u verwachtte, wat er in de plaats gebeurde.',
  'aide.feedback.send': 'Versturen',
  'aide.feedback.sending': 'Versturen…',
  'aide.feedback.sent': 'Bericht verstuurd. Bedankt, u krijgt een antwoord op uw adres.',
  'aide.feedback.stored': 'Bericht bewaard, maar de e-mail is niet vertrokken. Het wordt toch gelezen.',
  'password.title': 'Kies uw wachtwoord',
  'password.intro': 'Dit account is geopend met een tijdelijk wachtwoord. U moet het vervangen voor u verdergaat.',
  'password.current': 'Tijdelijk wachtwoord',
  'password.next': 'Nieuw wachtwoord',
  'password.confirm': 'Bevestiging',
  'password.rule': 'Minstens {n} tekens. Geen andere regel: een zin die u onthoudt, is beter dan een reeks symbolen.',
  'password.submit': 'Bewaren en doorgaan',
  'password.submitting': 'Bewaren…',
  'password.tooShort': 'Het nieuwe wachtwoord moet minstens {n} tekens tellen.',
  'password.mismatch': 'De twee invoeren komen niet overeen.',
  'password.error.generic': 'Wijzigen onmogelijk.',
  'password.error.same': 'Het nieuwe wachtwoord moet verschillen van het huidige.',
  'password.logout': 'Afmelden',
  'invite.title': 'Maak uw account aan',
  'invite.intro': 'Deze link opent een {produit}-account op het adres hieronder. Kies uw wachtwoord om te beginnen.',
  'invite.email': 'Adres van het account',
  'invite.submit': 'Mijn account aanmaken',
  'invite.submitting': 'Aanmaken…',
  'invite.loading': 'Link controleren…',
  'invite.gone.title': 'Deze link is niet meer geldig',
  'invite.gone.expiree': 'Hij is verlopen. Vraag een nieuwe link aan wie hem u stuurde.',
  'invite.gone.utilisee': 'Hij is al gebruikt om een account aan te maken. Meld u aan met het adres en het wachtwoord die u toen koos.',
  'invite.gone.revoquee': 'Hij is vervangen of geannuleerd. Vraag een nieuwe link aan wie hem u stuurde.',
  'invite.gone.inconnue': 'Deze link is onvolledig of fout. Controleer of hij volledig gekopieerd is.',
  'invite.gone.compte_existant': 'Er bestaat al een account op dit adres. Meld u aan met het wachtwoord ervan.',
  'invite.otherProduct': 'Deze link opent een account op een andere site.',
  'invite.otherProductOpen': 'De juiste site openen',
  'invite.toLogin': 'Naar de aanmelding',
  'invite.error.generic': 'Account aanmaken onmogelijk.',
  'candidature.stepToast': 'Stap: {label}',
  'candidature.propose': 'Voorstellen',
  'candidature.proposeName': '{name} voorstellen',
  'candidature.proposedToast': '{name} voorgesteld, de sollicitatie staat in de opvolging',
  'common.loading': 'Laden…',
  'common.close': 'Sluiten',
  'common.cancel': 'Annuleren',
  'common.update': 'Bijwerken',
  'common.import': 'Importeren',
  'importCv.updateTitle': '{name} bijwerken',
  'importCv.importing': 'Importeren…',
  'importCv.needFile': 'Kies een pdf-bestand',
  'importCv.updatedToast': 'Profiel van {name} bijgewerkt',
  'importCv.fileLabel': 'Cv (pdf)',
  'importCv.depot': 'Sleep de pdf hierheen, of klik om hem te kiezen',
  'importCv.fileHelp': 'Tekstextractie, structurering van het profiel door de AI, daarna vectorisering voor de matching (~10 s). De functietitel wordt in het cv gelezen.',
  'importCv.nameLabel': 'Naam (optioneel)',
  'importCv.namePlaceholder': 'Anders: gelezen in het cv',
  'gapQuestions.title': 'Voor het opstellen, {n} details',
  'gapQuestions.titleOne': 'Voor het opstellen, één detail',
  'gapQuestions.skip': 'Overslaan',
  'gapQuestions.generating': 'Bezig…',
  'gapQuestions.introPlural': 'De vacature vraagt dingen die het cv niet uitdrukkelijk vermeldt. Antwoorden of niet verandert niets aan het feit dat het cv aangepast wordt, enkel aan wat het kan benadrukken.',
  'gapQuestions.introSingular': 'De vacature vraagt iets wat het cv niet uitdrukkelijk vermeldt. Antwoorden of niet verandert niets aan het feit dat het cv aangepast wordt, enkel aan wat het kan benadrukken.',
  'gapQuestions.placeholder': 'Een ervaring om te vermelden, ook al was ze kort? Anders laat u het leeg.',
  'gapQuestions.answeredNone': 'Nog niets ingevuld, de aanpassing vertrekt zonder verrijking.',
  'gapQuestions.answeredPlural': '{n} antwoorden worden meegenomen.',
  'gapQuestions.answeredSingular': '1 antwoord wordt meegenomen.',
  'gapQuestions.noneNeeded': 'Geen vragen: het cv dekt de vacature al.',
  'vivier.loading': 'De pool laden…',
  'vivier.wentOnMission': '{name} op opdracht',
  'vivier.backOnBench': '{name} terug beschikbaar',
  'vivier.archivedToast': '{name} gearchiveerd, geschiedenis bewaard',
  'vivier.reactivatedToast': '{name} opnieuw actief',
  'vivier.summary': '{available} beschikbaar · {onMission} op opdracht · {archived} gearchiveerd',
  'vivier.showActive': 'De actieve pool bekijken',
  'vivier.showArchived': 'Gearchiveerd ({n})',
  'vivier.importCv': 'Een cv importeren',
  'vivier.avgScore': 'Gem. score',
  'vivier.evaluated': 'Beoordeeld',
  'vivier.positioned': 'Voorgesteld',
  'vivier.updated': 'Bijgew.',
  'vivier.reactivate': 'Opnieuw activeren',
  'vivier.onMission': 'Op opdracht',
  'vivier.onBench': 'Beschikbaar',
  'vivier.archive': 'Archiveren',
  'vivier.dropzoneTitle': 'Een cv als pdf importeren',
  'vivier.dropzoneHint': 'Extractie → gestructureerd profiel → vectorisering. Beoordeeld op de komende vacatures.',
  'vivier.noArchived': 'Geen gearchiveerde consultants.',
  'dossier.revert': '↩ terugzetten',
  'dossier.defautEnregistre': 'Instellingen bewaard voor uw volgende cv’s.',
  'modeles.sobre': 'Sober',
  'modeles.dates': 'Data links',
  'modeles.colonnes': 'Twee kolommen',
  'modeles.colonnes.note': 'Twee kolommen: sommige wervingssoftware leest dit slecht.',
  'modeles.compact': 'Compact',
  'modeles.perso': 'Mijn opmaak',
  'modeles.perso.complet': 'Met Compleet',
  'modeles.perso.note': 'Uit uw cv gehaald. Word houdt de standaardopmaak.',
  'modeles.perso.enCours': 'Wordt voorbereid',
  'modeles.perso.aPreparer': 'Voor te bereiden in Mijn cv',
  'modeles.parDefaut': 'Dit sjabloon dient voor uw volgende cv’s.',
  'config.modeleLabel': 'Opmaak',
  'config.modele.sobreEffet': 'Eén kolom, die alle wervingssoftware leest.',
  'config.modele.datesEffet': 'De data in een kolom, links van elke functie.',
  'config.modele.compactEffet': 'Compacter, om op minder pagina’s te passen.',
  'config.modele.persoEffet': 'Uit uw cv gehaald, met Radar Compleet.',
  'miseEnPage.titre': 'Mijn opmaak',
  'miseEnPage.texte': 'Uw aangepaste cv’s kunnen de opmaak van uw cv overnemen.',
  'miseEnPage.prete': 'Klaar.',
  'miseEnPage.choix': 'Het sjabloon van uw volgende cv’s, hetzelfde als in Instellingen.',
  'miseEnPage.enCours': 'Wordt voorbereid…',
  'miseEnPage.echec': 'Ze kon niet uit uw cv gehaald worden.',
  'miseEnPage.preparer': 'Mijn opmaak voorbereiden',
  'miseEnPage.refaire': 'Mijn opmaak opnieuw maken',
  'miseEnPage.sansPdf': 'Upload uw cv als pdf om de opmaak over te nemen.',
  'miseEnPage.complet': 'Met Radar Compleet.',
  'miseEnPage.formules': 'De formules bekijken',
  'miseEnPage.essai': 'Uw proefperiode bevat er één.',
  'dossier.revertedToast': 'Zin teruggezet, audit herberekend',
  'dossier.loadingFile': 'Document laden…',
  'dossier.notFound': 'Document niet gevonden',
  'dossier.regeneratingFile': 'Nieuwe versie wordt gemaakt…',
  'dossier.generatedOn': 'Gemaakt {date}',
  'dossier.ouvrirCv': 'Het cv openen',
  'dossier.savedToast': 'Cv bewaard, audit herberekend',
  'categories.loadError': 'Laden onmogelijk',
  'categories.title': 'Categorieën',
  'categories.close': 'Sluiten',
  'categories.edit': 'Wijzigen',
  'categories.empty': 'Geen categorie. Zolang er geen is, wordt deze fiche aan geen enkele vacature gekoppeld.',
  'categories.originHuman': 'verbeterd',
  'categories.originAi': 'voorgesteld',
  'categories.neighbours': 'Verwante categorieën',
  'categories.neighboursHelp': 'De verwante groepen van die hierboven. Ze leiden niet tot een automatische beoordeling, maar ze tonen wie er vlak naast staat.',
  'categories.selectedEmpty': 'Nog geen beroep. Typ er hieronder een.',
  'categories.remove': 'Verwijderen',
  'categories.searchLabel': 'Een beroep toevoegen',
  'categories.searchPlaceholder': 'Typ een beroep: ontwikkelaar, verpleegkundige, boekhouder…',
  'categories.noResult': 'Geen beroep gevonden. Probeer een ander woord.',
  'categories.saving': 'Bewaren…',
  'categories.save': 'Bewaren',
  'categories.savedToast': 'Categorieën bewaard',
  'suivi.loading': 'De opvolging laden…',
  'suivi.activeCountPlural': '{n} lopende sollicitaties',
  'suivi.activeCountSingular': '{n} lopende sollicitatie',
  'suivi.setAsideAt': 'voor later gehouden {when}',
  'suivi.putBackTitle': 'Terugzetten in “{name}”',
  'suivi.putBackToast': '“{title}” teruggezet in “{name}”',
  'suivi.closedSummary': '{placed} {placedLabel}, {refused} afgewezen',
  'suivi.offerGoneTitle': 'De vacature is van de site verdwenen',
  'suivi.offerExpired': 'vacature verlopen',
  'suivi.noMovementTitle': 'Geen beweging sinds {n} dagen',
  'suivi.daysShort': '{n} d',
  'suivi.openFileTitle': 'Openen: {name}',
  'suivi.noFileTitle': 'Er is geen aangepast cv gemaakt voor deze sollicitatie',
  'suivi.originalPosting': 'Oorspronkelijke vacature',
  'suivi.nextSend': 'De sollicitatie versturen',
  'suivi.preuveTitre': 'Mijn verstuurde sollicitaties',
  'suivi.preuveAide': 'Datum, werkgever en functie, voor de VDAB, Actiris of de Forem.',
  'suivi.preuveCopier': 'De lijst kopiëren',
  'suivi.preuveCopiee': 'Lijst gekopieerd.',
  'suivi.preuveEchec': 'Kopiëren onmogelijk vanuit deze browser.',
  'suivi.nextFollowUp': 'Opvolgen op {date}',
  'suivi.nextFollowUpDue': 'Nu opvolgen (gepland op {date})',
  'suivi.nextInterview': 'Het gesprek voorbereiden',
  'suivi.expiredTitle': 'Verlopen',
  'suivi.expiredHint': 'Vacatures die van de site verdwenen voor het versturen',
  'suivi.abandon': 'Opgeven',
  'suivi.abandonConfirm': 'Deze sollicitatie opgeven?',
  'suivi.abandonCancel': 'Annuleren',
  'suivi.removeAriaTitle': '“{title}” uit de opvolging halen',
  'suivi.removeAriaName': '{name} uit de opvolging halen',
  'suivi.removedToastTitle': '“{title}” uit de opvolging gehaald',
  'suivi.removedToastName': '{name} uit de opvolging gehaald',
  'veille.periodAll': 'Alle data',
  'veille.periodToday': 'Vandaag',
  'veille.period7d': 'Laatste 7 dagen',
  'veille.period30d': 'Laatste 30 dagen',
  'veille.loading': 'De opvolging laden…',
  'veille.subtitle': 'Alles wat de bronnen binnenbrachten · {n} opgevolgde vacatures',
  'veille.subtitleSingular': 'Alles wat de bronnen binnenbrachten · {n} opgevolgde vacature',
  'veille.searchPlaceholder': 'Zoeken…',
  'veille.searchAria': 'Zoeken',
  'veille.clearSearch': 'Zoekopdracht wissen',
  'veille.manualEntryButton': 'Handmatige invoer',
  'veille.allCompanies': 'Alle bedrijven',
  'veille.allLocations': 'Alle locaties',
  'veille.allConsultants': 'Alle consultants',
  'veille.periodAria': 'Periode',
  'veille.statusAria': 'Status',
  'veille.allStatuses': 'Alle statussen',
  'veille.shownPlural': '{n} vacatures getoond',
  'veille.shownSingular': '{n} vacature getoond',
  'veille.reset': 'Herstellen ({n})',
  'veille.colTitle': 'Vacature',
  'veille.colCompany': 'Bedrijf',
  'veille.colDetected': 'Gevonden',
  'veille.colStatus': 'Status',
  'veille.unread': 'Ongelezen',
  'veille.missionBadge': 'Opdracht',
  'veille.viewOriginal': 'De oorspronkelijke vacature bekijken',
  'veille.manualPlatform': 'handmatige invoer',
  'veille.noMatch': 'Geen enkele vacature komt overeen met deze filters.',
  'veille.resetFilters': 'Filters herstellen',
  'veille.evaluating': 'Beoordelen…',
  'veille.addedToast': 'Vacature toegevoegd, {n} profiel(en) beoordeeld',
  'veille.addAndEvaluate': 'Toevoegen en beoordelen',
  'veille.jobTitleLabel': 'Functietitel',
  'veille.jobTitlePlaceholder': 'Bv. Senior Backend Engineer, Java',
  'veille.companyLabel': 'Klant / bedrijf',
  'veille.locationLabel': 'Locatie',
  'veille.optional': 'Optioneel',
  'veille.briefLabel': 'Functieomschrijving',
  'veille.briefPlaceholder': 'Plak hier de volledige beschrijving…',
  'veille.briefHelp': 'Minstens 100 tekens. De vacature wordt meteen beoordeeld.',
  'consultant.loading': 'De fiche laden…',
  'consultant.backToBench': 'Terug naar de pool',
  'consultant.updatedOn': 'bijgewerkt op {date}',
  'consultant.printPdf': 'Afdrukken / pdf',
  'consultant.noDocument': 'Geen document.',
  'consultant.originalPdf': 'Oorspronkelijke pdf',
  'consultant.cvEdit': 'Wijzigen',
  'consultant.cvSave': 'Bewaren',
  'consultant.cvSaving': 'Bewaren…',
  'consultant.cvCancel': 'Annuleren',
  'consultant.cvSaved': 'Cv bewaard',
  'consultant.cvDiscard': 'De niet-bewaarde wijzigingen laten vallen?',
  'consultant.keywordsTitle': 'Wat terugkomt in uw vacatures',
  'consultant.keywordsIntroPlural': 'Op de {n} vacatures die al voor u beoordeeld zijn.',
  'consultant.keywordsIntroSingular': 'Op de {n} vacature die al voor u beoordeeld is.',
  'consultant.keywordsCovered': 'Wat uw cv al dekt',
  'consultant.keywordsMissing': 'Wat het vaakst ontbrak',
  'consultant.filesTotal': '{n} in totaal',
  'consultant.offerArchived': 'vacature gearchiveerd',
  'consultant.fidelityTitle': 'Trouw aan het master-cv: {n} %',
  'consultant.noEvent': 'Nog geen gebeurtenis.',
  'consultant.eventFidelity': ', trouw {n} %',
  'consultant.eventClient': ', {client}',
  'sources.addedToast': '{name} toegevoegd, {n} vacatures ingevoegd',
  'sources.alreadyKnownToast': 'Radar volgde deze site al op ({name}): u volgt hem nu',
  'sources.noneFollowed': 'U volgt nog geen enkele site. Plak hierboven het adres van een vacaturepagina, of blader door de sites die Radar al opvolgt.',
  'sources.browseTitle': 'Bladeren door de {n} sites die Radar al opvolgt',
  'sources.browseHelp': 'Ze worden voor andere accounts opgevolgd. Volg wat u interesseert: hun vacatures worden met uw cv vergeleken.',
  'sources.browseSearch': 'Een site of een bedrijf zoeken',
  'sources.browseNone': 'Geen enkele site komt overeen. Voeg hem hierboven toe via zijn adres.',
  'sources.loading': 'De bronnen laden…',
  'sources.title': 'Bronnen',
  'sources.activeSites': '{n} actieve sites',
  'sources.followedSites': '{n} gevolgde sites',
  'sources.followedSitesMax': '{n} / {max} gevolgde sites',
  'sources.errorCount': '{n} met een fout',
  'sources.watchedNightly': 'elke nacht opgevolgd',
  'sources.addTitle': 'Een site toevoegen, plak de url van de vacaturepagina',
  'sources.urlPlaceholder': 'https://jobs.voorbeeld.be',
  'sources.urlAria': 'Url van de vacaturepagina',
  'sources.detect': 'Herkennen',
  'sources.detecting': 'Platform herkennen en extractie testen…',
  'sources.unreachablePrefix': 'Pagina',
  'sources.unreachable': 'onbereikbaar',
  'sources.unreachableSuffix': ', controleer de url.',
  'sources.unsupportedPrefix': 'Platform',
  'sources.unsupported': 'nog niet ondersteund',
  'sources.unsupportedSuffix': '. Vandaag ondersteund:',
  'sources.requestExplain': 'Dit is niet het einde: vraag hieronder de activering aan. Een onbekende site vraagt een regel configuratie die met de hand geschreven wordt, het enige wat niet te raden valt. U krijgt een e-mail wanneer hij online is.',
  'sources.follow': 'Volgen',
  'sources.logoLabel': 'Logo',
  'sources.logoUrlPlaceholder': 'Adres van een afbeelding (https://…)',
  'sources.logoSet': 'Gebruiken',
  'sources.logoFile': 'Een bestand versturen',
  'sources.logoAuto': 'Het favicon van de site terugnemen',
  'sources.logoHelp': 'Een logo dat met de hand geplaatst is, wordt nooit meer door de automatische zoekopdracht vervangen. PNG, SVG, ICO, JPEG of WebP, hoogstens 512 kB.',
  'sources.logoUpdated': 'Logo bijgewerkt.',
  'sources.unfollow': 'Niet meer volgen',
  'sources.followed': '{name}: u volgt deze site. Radar leest en beoordeelt zijn vacatures, de voortgang verschijnt bovenaan het scherm.',
  'sources.followedStale': '{name}: u volgt deze site. Niemand volgde hem, zijn vacatures dateren van de laatste lezing ({date}): Radar leest hem nu opnieuw en beoordeelt daarna zijn vacatures.',
  'sources.notReadSince': 'Gelezen op {date}, opnieuw gelezen zodra u hem volgt',
  'sources.neverRead': 'Gelezen zodra u hem volgt',
  'sources.staleState': 'Vacatures van {date}, wacht op een nieuwe lezing',
  'accueil.sites.staleHelp': 'De sites met “niet opnieuw gelezen” worden gelezen zodra u klaar bent, voor hun vacatures beoordeeld worden.',
  'offre.staleSource': 'Gelezen op {date}, sindsdien niet opnieuw: ze is misschien al afgesloten',
  'offre.staleShort': 'niet opnieuw gelezen sinds {date}',
  'offre.republished': 'opnieuw gepubliceerd (verwijderd op {date})',
  'offre.republishedMany': '{n} keer gepubliceerd in 90 dagen',
  'offre.oldPosting': 'online sinds {n} dagen',
  'taches.cv': 'Uw cv',
  'taches.phase.attente': 'wacht',
  'taches.phase.lecture': 'vacatures lezen',
  'taches.phase.classement': 'indelen per beroep',
  'taches.phase.evaluation': 'vacatures beoordelen',
  'taches.phase.relecture': 'sites herlezen',
  'taches.unite.relecture': 'sites herlezen: {fait} van {total}',
  'taches.unite.lecture': 'pagina’s gelezen: {fait} van {total}',
  'taches.unite.classement': 'vacatures ingedeeld: {fait} van {total}',
  'taches.unite.evaluation': 'vacatures beoordeeld: {fait} van {total}',
  'taches.fini': 'klaar, {n} vacature(s) beoordeeld',
  'taches.finiEnAttente': 'klaar, {n} vacature(s) beoordeeld; {m} nog niet leesbaar, deze nacht beoordeeld',
  'taches.erreur': 'onderbroken ({message}), de nacht neemt het over',
  'sources.unfollowed': '{name}: u volgt deze site niet meer. Zijn vacatures verdwijnen van uw schermen, voor de anderen blijven ze.',
  'sources.followedLabel': 'Gevolgd',
  'sources.notFollowedLabel': 'Niet gevolgd',
  'sources.request': 'De activering aanvragen',
  'sources.requesting': 'Versturen…',
  'sources.requestNotePlaceholder': 'Optioneel: een detail, bijvoorbeeld de pagina met de vacatures',
  'sources.requestNoteAria': 'Detail bij de aanvraag',
  'sources.requestSent': 'Aanvraag bewaard. U krijgt een bevestigingsmail, en een tweede wanneer de site online is, meestal binnen {n} dagen.',
  'sources.requestSentNoMail': 'Aanvraag bewaard, maar de bevestigingsmail is niet vertrokken. Ze staat wel in de lijst hieronder.',
  'sources.requestFailed': 'Aanvraag onmogelijk.',
  'sources.pendingTitle': 'Sites die wachten op activering',
  'sources.pendingHelp': 'Aangevraagd, nog niet opgevolgd. U krijgt een e-mail zodra hij online is.',
  'sources.pendingNoMail': 'geen e-mail verstuurd voor deze aanvraag',
  'sources.recognizedPrefix': 'Herkend platform:',
  'sources.viaHtml': '(door de pagina te lezen)',
  'sources.offersFound': '{n} vacatures gevonden',
  'sources.preview': 'voorbeeld',
  'sources.actuallyWatched': 'Werkelijk opgevolgd portaal:',
  'sources.adding': 'Toevoegen…',
  'sources.addToWatch': 'Aan de opvolging toevoegen',
  'sources.addAnyway': 'Toch toevoegen',
  'sources.colCompany': 'Bedrijf',
  'sources.colPlatform': 'Platform',
  'sources.colHealth': 'Gezondheid',
  'sources.colLastCheck': 'Laatste controle',
  'sources.colOffers': 'Vacatures',
  'sources.errorLabel': 'Fout, {detail}',
  'sources.paused': 'Gepauzeerd',
  'sources.active': 'Actief',
  'sources.reactivatedToast': 'Bron opnieuw actief',
  'sources.pausedToast': 'Bron gepauzeerd',
  'sources.resume': 'Hervatten',
  'sources.pause': 'Pauzeren',
  'sources.removeTitle': 'Uit de opvolging halen',
  'sources.removedTitle': 'Uit de opvolging gehaald',
  'sources.removedAt': 'verwijderd {when}',
  'sources.wouldComeBack': '{n} vacatures zouden terugkomen',
  'sources.restoredToast': '{name} opnieuw opgevolgd, {n} vacature(s) teruggezet',
  'sources.restoreToWatch': 'Opnieuw opvolgen',
  'sources.removedToast': '{name} verwijderd, {n} vacature(s) gearchiveerd',
  'sources.editTitle': '{name} wijzigen',
  'sources.detecting2': 'Herkennen…',
  'sources.saving': 'Bewaren…',
  'sources.updatedToast': 'Bron bijgewerkt',
  'sources.save': 'Bewaren',
  'sources.companyLabel': 'Bedrijf',
  'sources.companyHelp': 'De naam die overal elders verschijnt: op de vacatures, in de opvolging en in de naam van de geëxporteerde cv’s. Leeg gelaten, dient de naam van de bron.',
  'sources.sourceNameLabel': 'Naam van de bron',
  'sources.sourceNameHelp': 'Om je in deze lijst terug te vinden, wanneer een bedrijf meerdere portalen heeft.',
  'sources.watchedUrlLabel': 'Opgevolgde url',
  'sources.urlWillRedetect': 'Het platform wordt op dit adres opnieuw herkend. Wordt het niet herkend, dan wordt er niets bewaard.',
  'sources.currentPlatform': 'Huidig platform: {platform}.',
  'sources.removeConfirmTitle': '{name} uit de opvolging halen?',
  'sources.removing': 'Verwijderen…',
  'sources.removeFromWatch': 'Uit de opvolging halen',
  'sources.removeConfirmP1': 'Ze wordt ’s nachts niet meer geraadpleegd, en haar {n} vacatures verlaten de opvolging.',
  'sources.removeConfirmP2': 'Er wordt niets gewist: de berekende scores, de gemaakte dossiers en de lopende sollicitaties blijven intact, en de bron wordt met één klik opnieuw opgevolgd. Zo kun je ze verwijderen zonder je af te vragen wat je verliest.',
  'decisions.loading': 'De stapel laden…',
  'decisions.nothingPending': 'Niets in afwachting',
  'decisions.countPlural': '{n} vacatures',
  'decisions.countSingular': '{n} vacature',
  'decisions.goodPlural': '{n} goede matches',
  'decisions.goodSingular': '{n} goede match',
  'decisions.lastRun': 'laatste run {when}',
  'decisions.searchAria': 'Zoeken in de stapel',
  'decisions.onboardTitle': 'Radar heeft u nog niets te tonen',
  'decisions.onboardIntro': 'Dat is normaal, uw account is net aangemaakt. Twee dingen om te doen, één keer, en de opvolging draait elke nacht zonder dat u eraan moet denken.',
  'decisions.onboardStep1Title': 'Uw cv opladen',
  'decisions.onboardStep1Help': 'Een pdf volstaat. Radar haalt er uw ervaring en vaardigheden uit, ongeveer twintig seconden. Dat cv is de referentie voor alle vergelijkingen.',
  'decisions.onboardStep1Action': 'Een pdf opladen',
  'decisions.onboardStep2Title': 'Sites kiezen om op te volgen',
  'decisions.onboardStep2Help': 'Plak het adres van een vacaturepagina. Radar herkent het platform zelf en toont wat hij kan lezen voor u bevestigt.',
  'decisions.onboardStep2Action': 'Een site toevoegen',
  'decisions.onboardNote': 'De eerste nacht van opvolging start zodra de eerste site toegevoegd is. U mag afsluiten, Radar gaat door.',
  'decisions.pileZeroText': 'Alles wat binnenkwam is beslist. De lopende voorstellen staan in',
  'decisions.pileZeroTracking': 'de opvolging',
  'decisions.pileZeroText2': 'en alles wat binnengehaald werd, blijft raadpleegbaar in',
  'decisions.pileZeroWatch': 'de opvolging van bronnen',
  'decisions.tierAria': 'Niveau van de match',
  'decisions.allScores': 'Alle scores',
  'decisions.selectAll': 'Alles selecteren',
  'decisions.selectedPlural': '{n} geselecteerd',
  'decisions.selectedSingular': '{n} geselecteerd',
  'decisions.batchLater': 'voor later gehouden',
  'decisions.later': 'Later',
  'decisions.batchSkipped': 'opzijgezet',
  'decisions.skip': 'Opzijzetten',
  'decisions.deselect': 'Deselecteren',
  'decisions.selectHint': 'Vink meerdere vacatures aan om ze in één keer opzij te zetten. Een vacature openen haalt ze niet van de stapel.',
  'decisions.shownOfTotal': '{shown} van {total}',
  'decisions.noMatch': 'Geen enkele vacature van de stapel komt overeen met deze filters.',
  'decisions.resetShort': 'Herstellen',
  'decisions.selectOffer': '{title} selecteren',
  'decisions.laterTitle': 'Ik bekijk ze later',
  'decisions.reopenedToast': '“{title}” hernomen, ze moet opnieuw beslist worden',
  'decisions.skippedTitle': 'Opzijgezet',
  'decisions.skippedHint': 'Er wordt niets verwijderd, u kunt op de beslissing terugkomen',
  'decisions.skippedAt': 'opzijgezet {when}',
  'decisions.reopenTitle': 'Terug op de stapel',
  'decisions.reopen': 'Hernemen',
  'decisions.skippedToast': '“{title}” opzijgezet',
  'decisions.laterToast': '“{title}” voor later gehouden',
  'decisions.appliedToast': '“{title}” toegevoegd aan uw sollicitaties',
  'decisions.sortButton': 'Sorteren ({n})',
  'decisions.thresholdLabel': 'Tonen vanaf',
  'decisions.thresholdEffect': '{n} van {total} vacatures te sorteren',
  'decisions.thresholdSaved': 'Drempel bewaard: {n}',
  'tri.title': 'Mijn kansen sorteren',
  'tri.progress': '{n} van {total}',
  'tri.close': 'Sluiten',
  'tri.doneTitle': 'Stapel gesorteerd',
  'tri.doneText': '{n} vacatures gesorteerd. Die u volgt, staan in uw sollicitaties.',
  'tri.noProfile': 'Geen score voor deze vacature: open de fiche om ze te beoordelen.',
  'decisions.batchToast': '{n} vacature(s): {action}',
  'decisions.tierGood': 'Goede match',
  'decisions.tierGoodRange': '70 en meer',
  'decisions.tierMid': 'Na te kijken',
  'decisions.tierMidRange': '40 tot 69',
  'decisions.tierLow': 'Zwakke match',
  'decisions.tierLowRange': 'onder 40',
  'offre.loading': 'De vacature laden…',
  'offre.notFound': 'Vacature niet gevonden',
  'offre.statusAriaLabel': 'Beslissing over deze vacature',
  'offre.kindMission': 'Opdracht',
  'offre.kindJob': 'Job',
  'offre.reperee': 'Gevonden op {date}',
  'offre.avisEnFrancais': 'Dit oordeel is in het Frans geschreven.',
  'offre.avisEnAnglais': 'Dit oordeel is in het Engels geschreven.',
  'offre.avisEnNeerlandais': 'Dit oordeel is in het Nederlands geschreven.',
  'offre.avisEnItalien': 'Dit oordeel is in het Italiaans geschreven.',
  'offre.avisEnEspagnol': 'Dit oordeel is in het Spaans geschreven.',
  'offre.avisRetraduit': 'Radar herschrijft het binnen enkele nachten in uw taal.',
  'offre.avisFaux': 'Lijkt dit oordeel u fout?',
  'offre.avisFauxMerci': 'Bedankt, genoteerd.',
  'offre.avisPour': 'Voor u',
  'offre.avisAVerifier': 'Na te kijken',
  'offre.avisAdapte': 'Met een aangepast cv: {n}',
  'offre.exigenceCouverte': 'Gedekt',
  'offre.exigenceAConfirmer': 'Te bevestigen',
  'offre.exigenceManquante': 'Ontbreekt',
  'offre.detailScore': 'Details van de score',
  'offre.annonceComplete': 'De volledige vacature',
  'offre.evaluatedProfilesPlural': '{n} profielen beoordeeld',
  'offre.evaluatedProfilesSingular': '{n} profiel beoordeeld',
  'offre.originalPosting': 'Oorspronkelijke vacature',
  'offre.deadlineValue': 'Vervaldatum: {value}',
  'offre.startValue': 'Gewenste start: {value}',
  'offre.endValue': 'Voorzien einde: {value}',
  'offre.notSetFem': 'niet vermeld',
  'offre.notSetMasc': 'niet vermeld',
  'offre.proposalsPlural': '{n} voorstellen ingediend',
  'offre.proposalsSingular': '{n} voorstel ingediend',
  'offre.proposalsUnset': 'aantal voorstellen niet vermeld',
  'offre.frameworkUnset': 'raamcontract niet vermeld',
  'offre.collapseDesc': 'De beschrijving inklappen',
  'offre.expandDesc': 'De volledige beschrijving lezen',
  'offre.noDescriptionCaptured': 'Geen beschrijving opgehaald.',
  'offre.applicationsHeader': 'Sollicitaties',
  'offre.proposedAgo': 'voorgesteld {when}',
  'offre.viewFileLink': 'het dossier bekijken',
  'offre.candidats': 'Kandidaten',
  'offre.aucunCandidat': 'Nog geen profiel beoordeeld.',
  'offre.compareName': '{name} vergelijken',
  'offre.scoreAriaLabel': '{name}: {score} op 100',
  'offre.onDemandTitle': 'Op je vraag beoordeeld, buiten de voorselectie',
  'offre.gainAfterAdaptation': '↑ {gain} na aanpassing',
  'offre.fileGeneratedTitle': 'Dossier aangemaakt',
  'offre.compareHintBase': 'Vink twee of meer profielen aan om ze naast elkaar te vergelijken,',
  'offre.compareOr': 'of',
  'offre.compareBest': 'vergelijk de {n} beste',
  'offre.compareFreeSuffix': ' het is al gratis en onmiddellijk, alles staat in de databank.',
  'offre.compareMax': 'Hoogstens {n} profielen in een vergelijking',
  'offre.journal': 'Logboek van de vacature',
  'offre.generatingFile': 'Dossier van {name} wordt gemaakt…',
  'offre.generatingHelp': 'Getrouwe herschrijving van het cv voor de vacature. Elke wijziging wordt geauditeerd.',
  'offre.comparedCount': '{n} profielen vergeleken op deze vacature',
  'offre.closeComparison': 'De vergelijking sluiten',
  'offre.generateTheirFile': 'Het dossier maken',
  'offre.applyTitle': 'Solliciteert u?',
  'offre.applyBody1': 'voegt ze toe aan uw sollicitaties, zonder iets te berekenen.',
  'offre.adaptCvLabel': 'Mijn cv aanpassen',
  'quota.restantes': 'Nog {n} van {max} aanpassingen deze week',
  'quota.aZero': 'Geen aanpassingen meer deze week. De teller begint maandag opnieuw.',
  'offre.applyBody2': 'herschrijft het voor deze vacature: dat is de enige stap die iets kost, en ze gebeurt enkel als u erom vraagt.',
  'offre.presentTitle': 'Klaar om {name} voor te stellen?',
  'offre.presentBody1': 'maakt de sollicitatie aan en volgt ze op, zonder iets op te roepen.',
  'offre.theFileLabel': 'Het dossier',
  'offre.presentBody2': '(cv herschreven voor de vacature + audit) is de enige stap die iets kost, en het wordt enkel gemaakt als je erom vraagt.',
  'offre.alreadyInApplications': 'al in uw sollicitaties',
  'offre.alreadyProposed': 'al voorgesteld',
  'offre.about15s': '~15 s',
  'offre.generateAdaptedFile': 'Het aangepaste dossier maken',
  'offre.emptyAnalysis': 'Nog geen beoordeling.',
  'offre.statusSkippedToast': 'Vacature opzijgezet',
  'offre.statusLaterToast': 'Opzijgelegd, ze staat in de opvolging',
  'offre.statusReopenedToast': 'Teruggezet bij de te nemen beslissingen',
  'offre.neighboursTitle': 'Profielen uit verwante categorieën',
  'offre.neighboursHelp': 'Ze delen de categorie van deze vacature niet, wel een verwante categorie. Ze worden niet automatisch beoordeeld.',
  'offre.scoredToast': '{name}: {score}/100',
  'offre.evaluate': 'Beoordelen',
  'offre.notYetEvaluated': 'Deze vacature is nog niet voor u beoordeeld',
  'offre.evaluatingLabel': 'Beoordelen…',
  'offre.alreadyScoredToast': 'Al beoordeeld: {score}/100',
  'offre.evaluatedToast': 'Beoordeeld: {score}/100',
  'offre.evaluateMyProfile': 'Mijn profiel beoordelen',
  'offre.evaluateHelp': '~3 s, één AI-oproep. Het resultaat wordt bewaard.',
  'offre.evaluateAnother': 'Een ander profiel beoordelen',
  'offre.employerUnknown': 'Werkgever niet vermeld',
  'offre.employerViaSource': 'via {source}',
  'offre.radarSkipToast': 'Niet voor mij: ze komt niet terug',
  'offre.radarLaterToast': 'Bewaard in Mijn vacatures. Radar herinnert u er maandag {date} aan als ze nog online is.',
  'offre.radarReopenToast': 'Beslissing geannuleerd',
  'decisions.skippedToastRadar': '“{title}”: niet voor mij',
  'decisions.reopenedToastRadar': '“{title}” staat opnieuw bij uw kansen',
  'sources.colState': 'Status',
  'sources.stateOk': 'OK',
  'sources.broken': 'Defect',
  'sources.brokenSince': 'Defect sinds {date}',
  'veille.notScored': 'Niet beoordeeld',
  'offre.appliedToast': 'Toegevoegd aan uw sollicitaties',
  'offre.descriptionTitle': 'De functie',
  'offre.behindTheScenes': 'Hoe Radar deze vacature verwerkte',
  'offre.generatingMyCv': 'Uw cv wordt aangepast…',
  'config.loading': 'De instellingen laden…',
  'config.saving': 'Bewaren…',
  'config.savedToast': 'Instellingen bewaard',
  'config.save': 'Bewaren',
  'config.sliderAria': 'Minimale score om op de stapel te komen',
  'config.scaleLow': '← alles zien, ook wat niet past',
  'config.scaleHigh': 'enkel de beste matches zien →',
  'config.computingEffect': 'Effect berekenen…',
  'config.thresholdReference': 'Ter referentie: de motor oordeelt “nee” onder 40, “misschien” tot 68, “ja” vanaf 70.',
  'config.optimizationLabel': 'Aanpassingsniveau',
  'config.optimizationBalanced': 'Evenwichtig',
  'config.optimizationTargeted': 'Gericht',
  'config.toneLabel': 'Toon',
  'config.toneSober': 'Sober',
  'config.toneDynamic': 'Dynamisch',
  'config.toneExecutive': 'Executive',
  'config.lengthLabel': 'Lengte',
  'config.languageLabel': 'Taal',
  'config.langue.auto': 'Die van de vacature',
  'config.langue.autoEffet': 'De taal van de vacature als uw cv zegt dat u ze spreekt, anders Engels.',
  'config.langue.fr': 'Frans',
  'config.langue.frEffet': 'Altijd in het Frans.',
  'config.langue.en': 'Engels',
  'config.langue.enEffet': 'Altijd in het Engels.',
  'config.length1Page': '1 pagina',
  'config.length2Pages': '2 pagina’s',
  'config.lengthUnlimited': 'Zonder limiet',
  'config.questionsLabel': 'Vragen voor het opstellen',
  'config.questionsOnce': 'Eén keer per vacature',
  'config.questionsAlways': 'Bij elke versie',
  'config.niveau.fidele': 'Getrouw',
  'config.niveau.audacieux': 'Gedurfd',
  'config.niveau.fideleEffet': 'Behoudt al uw regels, herschrijft en herschikt ze voor de vacature.',
  'config.niveau.equilibreEffet': 'Herschrijft vrij en kort wat minder dient een beetje in.',
  'config.niveau.cibleEffet': 'Behoudt wat de vacature dient, kort de rest in.',
  'config.niveau.audacieuxEffet': 'Kan beweren wat de vacature vraagt en wat uw cv niet zegt.',
  'config.ton.sobreEffet': 'Directe zinnen, zonder superlatieven.',
  'config.ton.dynamiqueEffet': 'Actiewerkwoorden, resultaten vooraan.',
  'config.ton.executifEffet': 'Sturing, visie, verantwoordelijkheden.',
  'config.longueur.unePageEffet': 'Enkel het essentiële voor deze vacature.',
  'config.longueur.deuxPagesEffet': 'Beknopt, zonder alles op te offeren.',
  'config.longueur.sansLimiteEffet': 'Geen enkele beperking in lengte.',
  'config.questions.aide': 'Over wat de vacature vraagt en wat uw cv niet zegt, daarna over de invalshoek van de brief.',
  'config.questions.uneFoisEffet': 'Gesteld bij de eerste versie voor een vacature, daarna niet meer.',
  'config.questions.toujoursEffet': 'Opnieuw gesteld voor elk cv en elke brief.',
  'compte.motDePasse': 'Wachtwoord',
  'compte.changer': 'Wijzigen',
  'compte.telecharger': 'Mijn gegevens downloaden',
  'compte.supprimer': 'Mijn account verwijderen',
  'compte.supprimerAide': 'Uw cv, uw sollicitaties, uw aangepaste cv’s en uw instellingen worden gewist. De facturen blijven bij Stripe. Dit is definitief.',
  'compte.supprimerConfirmer': 'Definitief verwijderen',
  'compte.actuel': 'Huidig wachtwoord',
  'compte.motDePasseAide': 'Minstens {n} tekens. Uw andere toestellen worden afgemeld.',
  'compte.enregistrer': 'Het wachtwoord wijzigen',
  'compte.actuelFaux': 'Het huidige wachtwoord is niet juist.',
  'config.signature': 'Handtekening',
  'config.authorLabel': 'Uw naam',
  'radar.moi': 'Ik',
  'radar.menuAria': 'Mijn account',
  'reglages.titre': 'Instellingen',
  'mails.quand': 'Wanneer',
  'marche.offres1': '1 vacature zoals de uwe deze maand',
  'marche.offres': '{n} vacatures zoals de uwe deze maand',
  'marche.chez1': 'bij 1 werkgever',
  'marche.chez': 'bij {e} werkgevers',
  'marche.salaire': 'Vermeld salaris: {min} tot {max} €.',
  'sugg.employeur': '{n} keer “Niet deze werkgever” voor {nom}.',
  'sugg.employeurAction': '{nom} dempen',
  'sugg.regions': '{n} keer “Te ver”.',
  'sugg.regionsAction': 'Uw regio’s kiezen',
  'sugg.salaire': '{n} keer geweigerd om het salaris.',
  'sugg.salaireAction': 'Een minimum instellen',
  'sugg.metier': '{n} keer “Niet mijn beroep”.',
  'sugg.metierAction': 'Uw beroepen herbekijken',
  'sugg.seuil': 'Er is al een week niets over uw drempel gegaan. Uw beste vacatures zitten op {n}.',
  'sugg.seuilAction': 'Naar {seuil} gaan',
  'sugg.seuilFait': 'Drempel op {seuil} gezet.',
  'cherche.placeholder': 'Zoeken in alle gevolgde vacatures',
  'cherche.rien': 'Geen vacatures.',
  'tri.ouvrir': 'Snel sorteren',
  'tri.titre': 'Snel sorteren · {n} / {total}',
  'tri.voir': 'Bekijken',
  'tri.plusTard': 'Later',
  'tri.pasPourMoi': 'Niet voor mij',
  'tri.passer': 'Volgende zonder te beslissen',
  'tri.fermer': 'Sluiten',
  'tri.fini': 'Alles is gesorteerd.',
  'tri.plusTardOk': 'Bewaard voor later.',
  'tri.pasPourMoiOk': 'Opzijgezet.',
  'excl.cdd': 'Tijdelijk contract',
  'excl.interim': 'Interim',
  'excl.freelance': 'Freelance',
  'excl.stage': 'Stage',
  'excl.junior': 'Junior',
  'excl.senior': 'Senior',
  'excl.langues': 'Vereiste talen die ik niet spreek',
  'excl.salaire': 'Minimaal bruto jaarsalaris',
  'excl.contrats': 'Aanvaarde contracten',
  'excl.cdi': 'Vast contract',
  'excl.confirme': 'Ervaren',
  'excl.niveaux': 'Niveaus die bij mij passen',
  'excl.teletravail': 'Telewerk',
  'excl.temps': 'Arbeidstijd',
  'excl.tempsPlein': 'Voltijds',
  'excl.tempsPartiel': 'Deeltijds of 4/5',
  'excl.peuImporte': 'Maakt niet uit',
  'excl.hybride': 'Minstens hybride',
  'excl.salaireAucun': 'Geen',
  'excl.salaireAutre': 'Ander…',
  'excl.k': '{n} k€',
  'excl.parAn': '€ bruto per jaar',
  'excl.jeParle': 'Ik spreek',
  'excl.parle.fr': 'Frans',
  'excl.parle.nl': 'Nederlands',
  'excl.parle.en': 'Engels',
  'excl.parle.de': 'Duits',
  'reglages.cherche.titre': 'Wat ik zoek',
  'reglages.cherche.aide': 'Geldt voor de mails en het startscherm. Een vacature die over een punt niets zegt, gaat altijd door.',
  'reglages.regions': 'Waar',
  'reglages.ecrit.titre': 'Wanneer Radar mij schrijft',
  'reglages.avance': 'Geavanceerd',
  'reglages.compte.titre': 'Mijn account',
  'reglages.mails.coupesIci': 'De mails zijn uitgeschakeld. U schakelt ze opnieuw in bij “Mijn account”.',
  'mails.matin': 'Dezelfde ochtend',
  'mails.hebdo': 'Enkel op maandag',
  'mails.quels': 'Welke mails',
  'mails.mots': 'Gevolgde woorden',
  'mails.motsAide': 'Een nieuwe vacature die een ervan bevat, gaat per mail, wat de score ook is. Hoogstens tien, gescheiden door komma’s.',
  'mails.motsExemple': 'Kubernetes, product owner',
  'mails.lundi': 'Overzicht op maandag',
  'mails.relance': 'Opvolging na 7 dagen',
  'mails.accueil': 'Drempel van het startscherm',
  'mails.commeMails': 'Zoals de mails ({n})',
  'mails.saved': 'Bewaard.',
  'mails.prioritaire': 'Voorrang',
  'mails.muet': 'Gedempt',
  'mails.prioritaireAide': 'Elke vacature in uw beroepen gaat per mail.',
  'mails.muetAide': 'Geen mails meer voor deze werkgever.',
  'reglages.mails.coupes': 'U ontvangt geen mails van Radar meer. Hij blijft opvolgen: uw vacatures blijven hier.',
  'reglages.mails.reactiver': 'Opnieuw mails ontvangen',
  'reglages.mails.couper': 'Geen mails meer ontvangen',
  'rythme.aria': 'Ritme van de mails',
  'rythme.discret.nom': 'Discreet',
  'rythme.discret.seuil': '80 en meer',
  'rythme.discret.desc': 'Enkel vacatures die heel dicht bij uw cv liggen.',
  'rythme.equilibre.nom': 'Evenwichtig',
  'rythme.equilibre.seuil': '70 en meer',
  'rythme.equilibre.desc': 'Vacatures die dicht bij uw cv liggen.',
  'rythme.actif.nom': 'Ik zoek actief',
  'rythme.actif.seuil': '60 en meer',
  'rythme.actif.desc': 'Ook vacatures die iets verder afstaan.',
  'rythme.estimationZero': 'Geen vacatures in de laatste 30 dagen',
  'rythme.estimationUn': '1 vacature in de laatste 30 dagen',
  'rythme.estimationPlus': '{n} vacatures in de laatste 30 dagen',
  'rythme.note': 'Geteld op uw werkgevers in de laatste 30 dagen. Eén nacht, hoogstens één mail.',
  'rythme.perso': 'Uw huidige drempel, {n}, is met de hand ingesteld. Een ritme kiezen vervangt hem.',
  'accueil2.sansCv': 'Radar vergelijkt elke vacature met uw cv. Zonder cv heeft hij u niets te tonen.',
  'accueil2.sansCvAction': 'Mijn cv opladen',
  'accueil2.titreNouvelleUn': 'Een nieuwe vacature gaat over uw drempel van {seuil}.',
  'accueil2.titreNouvellesPlus': '{n} nieuwe vacatures gaan over uw drempel van {seuil}.',
  'accueil2.titreAttenteUn': 'Een vacature boven {seuil} wacht op u.',
  'accueil2.titreAttentePlus': '{n} vacatures boven {seuil} wachten op u.',
  'accueil2.titreCalme': 'Niets nieuws boven {seuil}.',
  'accueil2.aucunSuivi': 'U volgt nog geen enkele werkgever.',
  'accueil2.aFaire': 'Te doen',
  'accueil2.finFile': 'Dat is alles voor vandaag.',
  'file.aria': 'Te sorteren vacatures',
  'file.position': 'Vacature {rang} van {total}',
  'file.suivante': 'Volgende',
  'file.terminer': 'Afronden',
  'accueil2.etat': 'Radar heeft uw sites {quand} opnieuw gelezen.',
  'accueil2.etatPremiere': 'Eerste lezing van uw sites deze nacht.',
  'accueil2.lundi': 'Overzicht op maandag, ook zonder nieuws.',
  'accueil2.mailsCoupes': 'U ontvangt geen mails.',
  'accueil2.mailsReactiver': 'Opnieuw inschakelen',
  'accueil2.pause': 'Mails gepauzeerd tot {date}',
  'accueil2.reprendre': 'Nu hervatten',
  'pause.titre': 'Een pauze nemen',
  'pause.uneSemaine': '1 week',
  'pause.semaines': '{n} weken',
  'pause.jusqua': 'Gepauzeerd tot {date}',
  'accueil2.pourVous': 'Voor u',
  'accueil2.pourVousPlus': 'De {n} beste van {total}.',
  'accueil2.nouvelle': 'Nieuw',
  'accueil2.via': 'via {site}',
  'accueil2.atoutsLabel': 'Voor u:',
  'accueil2.manquesLabel': 'Na te kijken:',
  'accueil2.tranchee': '{etat}: {titre}',
  'accueil2.dessousTitre': 'Net eronder',
  'accueil2.plusProches': 'De dichtstbijzijnde',
  'accueil2.dessousUn': '1 vacature tussen {min} en {max} deze week',
  'accueil2.dessousPlus': '{n} vacatures tussen {min} en {max} deze week',
  'accueil2.dessousNote': 'Ze zijn u niet per mail gestuurd.',
  'accueil2.changerRythme': 'Mijn ritme wijzigen',
  'accueil2.choisirEmployeurs': 'Mijn werkgevers kiezen',
  'accueil2.empErreur': 'Momenteel onleesbaar. Het team is verwittigd, u hoeft niets te doen.',
  'accueil2.empAnnonces': 'Vacaturesite: {n} vacatures in uw beroepen, de beste op {m}',
  'accueil2.empAnnoncesRien': 'Vacaturesite: voorlopig niets in uw beroepen',
  'accueil2.empAnnoncesUn': 'Vacaturesite: 1 vacature in uw beroepen, op {m}',
  'accueil2.empRecrutePlus': 'Werft aan in uw beroepen: {n} vacatures, de beste op {m}',
  'accueil2.empRecruteUn': 'Werft aan in uw beroepen: 1 vacature, op {m}',
  'accueil2.empCalme': 'Rustig in uw beroepen.',
  'accueil2.enCoursUn': '1 lopende sollicitatie',
  'accueil2.enCoursPlus': '{n} lopende sollicitaties',
  'bienvenue.etape': 'Stap {n} van 3',
  'bienvenue.cv.titre': 'Eerst uw cv',
  'bienvenue.cv.sous': 'Radar leest het één keer en gebruikt het daarna om elke vacature te vergelijken. Het blijft privé.',
  'bienvenue.essai': 'Radar is een maand gratis, zonder kaart.',
  'bienvenue.cv.extension': 'Uw extensie heeft uw cv al.',
  'bienvenue.cv.reprendre': 'Overnemen',
  'bienvenue.cv.reprendreEchec': 'Het cv van de extensie kon niet worden gelezen.',
  'ext.installee': 'Uw extensie is geïnstalleerd.',
  'ext.connecter': 'Verbinden',
  'ext.connectee': 'Extensie verbonden.',
  'ext.echec': 'Verbinden is mislukt. Probeer opnieuw.',
  'ext.echecSansCv': 'Laad eerst uw cv op in Radar.',
  'bienvenue.cv.depot': 'Sleep uw cv als pdf hierheen',
  'bienvenue.cv.ou': 'of tik om een bestand te kiezen',
  'bienvenue.cv.lecture': 'Radar leest uw cv, een twintigtal seconden…',
  'bienvenue.cv.lu': 'Uw cv is gelezen.',
  'bienvenue.cv.luNom': 'Uw cv is gelezen: {nom}.',
  'bienvenue.cv.metiers': 'Radar zoekt functies als',
  'bienvenue.cv.metiersAide': 'Verwijder wat u niet aanbelangt, voeg toe wat ontbreekt. Radar beoordeelt enkel de vacatures van deze beroepen.',
  'bienvenue.cv.suivant': 'Dat ben ik',
  'bienvenue.emp.titre': 'Bij wie zou u morgen ja zeggen?',
  'bienvenue.emp.sous': 'Kies tot {max} sites. Radar leest hun vacatures elke nacht opnieuw. Ze zijn gesorteerd volgens uw beroepen.',
  'bienvenue.emp.sousSansMax': 'Radar leest hun vacatures elke nacht opnieuw. Ze zijn gesorteerd volgens uw beroepen.',
  'bienvenue.emp.dansMetiers': '{n} in uw beroepen',
  'bienvenue.emp.rien': 'Vandaag niets in uw beroepen',
  'bienvenue.emp.annoncesTitre': 'Vacaturesites',
  'bienvenue.emp.annoncesAide': 'Ze publiceren voor honderden werkgevers, en Radar houdt er enkel uw beroepen van over. Standaard aangevinkt: de meeste goede vacatures komen van hen.',
  'bienvenue.emp.employeursTitre': 'Werkgevers',
  'bienvenue.emp.manque': 'Staat uw werkgever er niet bij? Voeg het adres van zijn vacaturepagina toe via het tabblad Werkgevers, zodra uw radar klaarstaat.',
  'bienvenue.continuer': 'Doorgaan',
  'bienvenue.retour': 'Terug',
  'bienvenue.rythme.titre': 'Wanneer wilt u gestoord worden?',
  'bienvenue.rythme.pasEncore': 'Radar vergelijkt nu de vacatures van uw sites met uw cv. Vanaf morgen ziet u in uw instellingen hoeveel elk ritme er verstuurt.',
  'bienvenue.fin': 'Mijn radar instellen',
  'offre.vpQuestion': 'Solliciteert u?',
  'offre.vpOui': 'Ja, mijn cv voorbereiden',
  'offre.vpCvPret': 'Uw cv is klaar.',
  'offre.vpSansAdapter': 'Ik solliciteer zonder mijn cv aan te passen',
  'suivi.aDecider': 'Uw bewaarde vacatures',
  'suivi.aDeciderAide': 'Bewaard via de extensie of met de hand toegevoegd.',
  'suivi.gardeeLe': 'Bewaard op {date}',
  'regions.question': 'Waar wilt u werken?',
  'regions.aide': 'Niets aangevinkt: overal. Een vacature elders wordt nooit per mail gestuurd, maar blijft zichtbaar bij haar werkgever. Een vacature zonder gekende plaats gaat altijd door.',
  'regions.aria': 'Regio’s',
  'regions.bruxelles': 'Brussel',
  'regions.wallonie': 'Wallonië',
  'regions.flandre': 'Vlaanderen',
  'regions.luxembourg': 'Luxemburg',
  'regions.etranger': 'Buiten België en Luxemburg',
  'filtre.titre': 'Wat volgen bij {nom}?',
  'filtre.aide': '{n} vacatures online. Vink minstens één zone of één taal aan.',
  'filtre.aidePetit': '{n} vacatures online. Niets aangevinkt: alles.',
  'filtre.aideTraduite': '{n} vacatures, elk in meerdere talen gepubliceerd. Kies er een.',
  'filtre.lecture': 'Radar leest {n} vacatures per nacht, de recentste eerst.',
  'emp.enLecture': 'Bezig met lezen: de recentste eerst.',
  'filtre.zones': 'Waar',
  'filtre.langues': 'Taal van de vacature',
  'filtre.suivre': 'Volgen',
  'filtre.enregistrer': 'Bewaren',
  'filtre.enregistre': 'Filter bewaard.',
  'filtre.changer': 'De filter wijzigen',
  'filtre.vide': 'Geen leesbare zone of taal op deze site.',
  'zones.brabant-wallon': 'Waals-Brabant',
  'zones.hainaut': 'Henegouwen',
  'zones.liege': 'Luik',
  'zones.luxembourg-be': 'Provincie Luxemburg',
  'zones.namur': 'Namen',
  'zones.anvers': 'Antwerpen',
  'zones.brabant-flamand': 'Vlaams-Brabant',
  'zones.flandre-occidentale': 'West-Vlaanderen',
  'zones.flandre-orientale': 'Oost-Vlaanderen',
  'zones.limbourg': 'Limburg',
  'zones.france': 'Frankrijk',
  'zones.pays-bas': 'Nederland',
  'zones.allemagne': 'Duitsland',
  'zones.suisse': 'Zwitserland',
  'zones.autre-pays': 'Andere landen',
  'langues.fr': 'Frans',
  'langues.nl': 'Nederlands',
  'langues.en': 'Engels',
  'langues.de': 'Duits',
  'accueil2.horsRegionsUn': '1 andere vacature boven {seuil} ligt buiten uw regio’s.',
  'accueil2.horsRegionsPlus': '{n} andere vacatures boven {seuil} liggen buiten uw regio’s.',
  'accueil2.exclueUn': '1 vacature opzijgezet door uw criteria.',
  'accueil2.excluesPlus': '{n} vacatures opzijgezet door uw criteria.',
  'accueil2.changerCriteres': 'Uw criteria',
  'accueil2.changerRegions': 'Mijn regio’s wijzigen',
  'emp.calmeDepuis': 'Rustig in uw beroepen. Laatste vacature {n} weken geleden.',
  'raison.question': 'Waarom? (optioneel)',
  'aide.code.bouton': 'Een aanmeldcode tonen',
  'aide.code.aide': 'In de extensie, Opties, “Aanmelden met een Radar-code”: typ deze code. Geen wachtwoord opnieuw te typen. 10 minuten geldig, één keer.',
  'aide.code.aria': 'Aanmeldcode van de extensie',
  'aide.pont.ok': 'Extensie verbonden. U mag dit tabblad sluiten.',
  'aide.pont.echec': 'De extensie kon niet verbinden. Probeer opnieuw vanuit de extensie.',
  'aideR.intro': 'De extensie, en wat te doen als het vastloopt.',
  'aideR.ext.titre': 'De extensie',
  'aideR.ext.lead': 'Uw score op elke vacature, LinkedIn inbegrepen.',
  'aideR.ext.telephone': 'Ze wordt op een computer geïnstalleerd, in Chrome. Open Radar op uw computer en daarna “Hulp en extensie”.',
  'aideR.ext.dejaInstallee': 'Al geïnstalleerd? Verbind ze',
  'aideR.ext.pasInstallee': 'Nog niet geïnstalleerd? Installeer ze',
  'aideR.ext.pasDeBouton': 'Geen knop “Verbinden met Radar”? Gebruik een code:',
  'aideR.ext.connectee': 'Extensie verbonden',
  'aideR.ext.nonConnectee': 'De extensie is niet verbonden',
  'aideR.ext.rienEnvoye': 'Nog geen vacature via haar verstuurd.',
  'aideR.ext.dernierEnvoi': 'Laatste verzending: {date}.',
  'aideR.ext.ailleurs': 'Op LinkedIn en Indeed schakelt ze zichzelf in. Elders toont u haar de site één keer:',
  'demo.pause': 'Pauze',
  'demo.lecture': 'Afspelen',
  'demo.reduit': 'Animatie uitgeschakeld: “beweging beperken” staat aan.',
  'demo.annuler': 'Annuleren',
  'demo.refuser': 'Weigeren',
  'demo.autoriser': 'Toestaan',
  'demo.install.titre': 'Installeren en vastmaken',
  'demo.install.aria': 'Animatie: in de Chrome Web Store op “Toevoegen aan Chrome” klikken, bevestigen, daarna het puzzelstukje openen en de extensie vastmaken. Haar pictogram verschijnt in de balk.',
  'demo.install.e1': '“Toevoegen aan Chrome”',
  'demo.install.e2': '“Extensie toevoegen”',
  'demo.install.e3': 'Het puzzelstukje, daarna de punaise',
  'demo.install.slogan': 'Uw score op elke vacature',
  'demo.install.dlgTitre': '“AI Job Fit” toevoegen?',
  'demo.install.dlgTexte': 'Ze kan de vacatures lezen die u opent.',
  'demo.install.menu': 'Extensies',
  'demo.install.ajouter': 'Extensie toevoegen',
  'demo.ac.bouton': 'Inschakelen op deze site',
  'demo.ac.emp': 'UZ Voorbeeld · Gent',
  'demo.co.titre': 'Verbinden met Radar',
  'demo.co.aria': 'Animatie: in de opties van de extensie op “Heb je een Radar-account?” klikken, daarna op “Verbinden met Radar”, toestaan. Radar bevestigt in een tabblad, en het cv komt in de extensie aan.',
  'demo.co.e1': '“Heb je een Radar-account?”',
  'demo.co.e2': '“Verbinden met Radar”, daarna “Toestaan”',
  'demo.co.e3': 'Radar bevestigt in een tabblad',
  'demo.co.e4': 'Uw cv staat in de extensie',
  'demo.co.import': 'Importeer je cv om te beginnen',
  'demo.co.depot': 'Laad je cv op',
  'demo.co.lien': 'Heb je een Radar-account? Meld je aan',
  'demo.co.compte': 'Ik heb een Radar-account',
  'demo.co.bouton': 'Verbinden met Radar',
  'demo.co.ouBien': 'Of: wachtwoord, of Radar-code',
  'demo.co.perm': 'Toegang tot Radar toestaan?',
  'demo.co.fermer': 'U mag dit tabblad sluiten.',
  'demo.co.cv': 'Je cv komt uit Radar',
  'demo.co.nom': 'Uw naam',
  'demo.co.metier': 'Uw beroep',
  'demo.co.bouton2': '“Bewaren in Radar” verschijnt op elke vacature.',
  'demo.ac.titre': 'Inschakelen op een onbekende site',
  'demo.ac.aria': 'Animatie: op de vacature van een werkgeverssite op het pictogram van de extensie klikken, daarna op “Inschakelen op deze site”, toestaan. De score verschijnt op de vacature.',
  'demo.ac.e1': 'Het pictogram van de extensie',
  'demo.ac.e2': '“Inschakelen op deze site”',
  'demo.ac.e3': '“Toestaan”, één keer per site',
  'demo.ac.e4': 'De score verschijnt op de vacature',
  'demo.ac.poste': 'Financieel analist (m/v/x)',
  'demo.ac.pasAcces': 'Nog niet actief op deze site.',
  'demo.ac.perm': 'Toestaan op deze site?',
  'demo.ac.profil': 'Goed profiel',
  'demo.ac.adapter': 'Mijn cv aanpassen',
  'demo.ac.enregistrer': 'Bewaren in Radar',
  'demo.emp.titre': 'Een werkgever die nog niet gevolgd wordt',
  'demo.emp.aria': 'Animatie: u vraagt de activering aan, een mail bevestigt meteen, een tweede mail zegt dat de werkgever online is, meestal binnen een week.',
  'demo.emp.l1': 'U vraagt aan',
  'demo.emp.l1s': '“De activering aanvragen”',
  'demo.emp.l2': 'Een mail bevestigt',
  'demo.emp.l2s': 'meteen',
  'demo.emp.l3': 'Het staat online',
  'demo.emp.l3s': 'meestal binnen een week',
  'aideR.faq.titre': 'Als het vastloopt',
  'aideR.q.score': 'Geen score op een vacature',
  'aideR.r.score': 'Op een site die ze niet kent, wacht de extensie op uw toestemming. Eén keer per site:',
  'aideR.r.scoreTel': 'Op een site die ze niet kent, wacht de extensie op uw toestemming: klik op haar pictogram en daarna op “Inschakelen op deze site”. Eén keer per site.',
  'aideR.q.reconnait': 'De extensie herkent me niet meer',
  'aideR.r.reconnait': 'Nieuwe computer, gewijzigd wachtwoord: verbind ze opnieuw. In haar opties, “Verbinden met Radar”, of typ deze code:',
  'aideR.q.employeur': 'Een werkgever staat niet in de lijst',
  'aideR.r.employeur': 'Voeg het adres van zijn vacaturepagina toe bij Werkgevers. Kan Radar ze nog niet lezen, vraag dan de activering aan. Dat is geen storing.',
  'aideR.cta.employeur': 'Naar de werkgevers',
  'aideR.q.mails': 'Ik ontvang de mails niet',
  'aideR.r.mails': 'Kijk eerst bij de ongewenste berichten. Een bedrijfsadres filtert Radar soms: probeer een persoonlijk adres.',
  'aideR.cta.adresse': 'Ander adres gebruiken',
  'aideR.q.rythme': 'Te veel mails, of te weinig',
  'aideR.r.rythme': 'Kies een ander ritme. Elk zegt hoeveel vacatures het u gestuurd zou hebben.',
  'aideR.cta.rythme': 'Ander ritme kiezen',
  'aideR.q.pause': 'Ik ga op vakantie',
  'aideR.r.pause': 'Pauzeer de mails een, twee of vier weken. Ze komen vanzelf terug.',
  'aideR.cta.pause': 'Pauzeren',
  'aideR.q.supprimer': 'Mijn account verwijderen',
  'aideR.r.supprimer': 'Onderaan de Instellingen. Uw cv en uw scores worden gewist. U kunt eerst uw gegevens downloaden.',
  'aideR.cta.compte': 'Mijn account openen',
  'aideR.prive.titre': 'Wat privé blijft',
  'aideR.prive.texte': 'Uw cv, uw scores en uw sollicitaties zijn enkel voor u zichtbaar. De gevolgde werkgevers en hun vacatures zijn gemeenschappelijk voor alle accounts.',
  'aideR.ecrire.titre': 'Ons schrijven',
  'aideR.ecrire.texte': 'Een bug, een idee, een site om toe te voegen: het bericht komt per mail aan, met uw adres voor het antwoord.',
  'manques.titre': 'Wat uw vacatures vragen en uw cv niet zegt',
  'manques.intro': 'Op de {n} vacatures van uw beroepen in de laatste 30 dagen. Hebt u het, schrijf het dan: uw volgende scores houden er rekening mee.',
  'manques.chez': 'gevraagd bij {liste}',
  'manques.sitesAnnonces': 'vacaturesites',
  'manques.jeLai': 'Ik heb het',
  'manques.ajoute': '“{mot}” toegevoegd aan uw cv, bij uw vaardigheden.',
  'manques.annuler': 'Annuleren',
  'manques.retire': '“{mot}” uit uw cv verwijderd.',
  'manques.nAria': 'Gevraagd door {n} vacatures',
  'adresse.actuelle': 'Radar schrijft u op {email}.',
  'adresse.changer': 'Een ander adres gebruiken',
  'adresse.placeholder': 'Uw persoonlijk adres',
  'adresse.envoyer': 'De bevestigingslink versturen',
  'adresse.aide': 'Een werkadres? Uw jobalerts zouden dan op de server van uw werkgever gelezen worden. Een ander adres wordt via een link bevestigd.',
  'adresse.attente': 'Wacht op bevestiging: {attente}.',
  'adresse.statut.lienLe': 'Link verstuurd: {quand}.',
  'adresse.statut.envoye': 'Brevo heeft het overgenomen, nog geen nieuws van de ontvangende server.',
  'adresse.statut.livre': 'Aanvaard door de server van dit adres.',
  'adresse.statut.differe': 'Uitgesteld door de server van dit adres, nieuwe poging bezig.',
  'adresse.statut.refuse': 'Geweigerd door de server van dit adres: {raison}',
  'adresse.statut.pasParti': 'De link is niet vertrokken: {erreur}',
  'adresse.statut.pasRecu': 'Niet ontvangen? Kijk bij de ongewenste berichten of de quarantaine van uw mailbox.',
  'adresse.renvoyer': 'De link opnieuw versturen',
  'adresse.lienToast': 'Link verstuurd naar {email}. Radar schrijft er zodra hij geopend is.',
  'adresse.compteToast': 'Radar schrijft u opnieuw op het adres van uw account.',
  'adresse.echecToast': 'De link kon niet vertrekken. Probeer later opnieuw.',
  'adresse.confirmee': 'Adres bevestigd: Radar schrijft u voortaan daar.',
  'adresse.lienInvalide': 'Deze bevestigingslink is niet meer geldig. Vraag een nieuwe aan.',
  'parcours.aria': 'Uw sollicitatie, stap voor stap',
  'parcours.cv': 'Uw cv voor {employeur}',
  'parcours.cvSans': 'Uw aangepast cv',
  'parcours.cvPret': 'Klaar. Bekijken en aanpassen hieronder.',
  'parcours.cvPretEstime': 'Klaar. Geschatte score met dit cv: {estime} in plaats van {score}.',
  'parcours.lettre': 'Uw brief (optioneel)',
  'parcours.lettreRediger': 'De brief schrijven',
  'parcours.lettreNon': 'Ik heb er geen nodig',
  'parcours.postuler': 'Solliciteren bij {employeur}',
  'parcours.postulerSans': 'Solliciteren via de vacature',
  'parcours.ouvrirPage': 'De sollicitatiepagina openen',
  'parcours.dejaFait': 'Gedaan',
  'parcours.envoye': 'Verstuurd?',
  'parcours.envoyeOui': 'Ja, verstuurd',
  'parcours.envoyeNon': 'Ik verstuur ze niet',
  'parcours.envoyeToast': 'Genoteerd: verstuurd.',
  'parcours.envoyeNonToast': 'Genoteerd: ze verlaat uw vacatures.',
  'parcours.envoyeLe': 'Verstuurd op {date}. Zonder nieuws tegen {relance} stelt Radar u een opvolging voor.',
  'suivi.lienPlaceholder': 'De link van een vacature plakken',
  'suivi.lienAria': 'Link van een vacature',
  'suivi.lienAjouter': 'Toevoegen',
  'suivi.lienLecture': 'De pagina lezen…',
  'suivi.lienIllisible': '{raison} Plak de tekst hieronder.',
  'offre.lienLater': 'U koos “Later” in de mail: bevestig met één klik.',
  'offre.lienSkip': 'U koos “Niet voor mij” in de mail: bevestig met één klik.',
  'raison.loin': 'Te ver',
  'raison.metier': 'Niet mijn beroep',
  'raison.salaire': 'Salaris',
  'raison.employeur': 'Niet deze werkgever',
  'raison.autre': 'Andere',
  'raison.merci': 'Bedankt, genoteerd.',
  'suivi.rappelLe': 'herinnering op maandag {date}',
  'emp.pourVousUn': '1 vacature voor u van {n} in uw beroepen, de beste op {m}.',
  'emp.pourVousPlus': '{k} vacatures voor u van {n} in uw beroepen, de beste op {m}.',
  'emp.uneSeule': '1 vacature in uw beroepen, op {m}: ze gaat over uw drempel.',
  'emp.sousSeuil': '{n} vacatures in uw beroepen, geen enkele op {seuil} of meer. De beste: {m}.',
  'emp.sousSeuilUn': '1 vacature in uw beroepen, op {m}: onder uw drempel van {seuil}.',
  'emp.prefixeAnnonces': 'Vacaturesite · {phrase}',
  'emp.retour': 'Werkgevers',
  'emp.introuvable': 'Deze werkgever wordt niet meer door Radar gevolgd.',
  'emp.suiviDepuis': 'gevolgd sinds {date}',
  'emp.dansMetiersTitre': 'In uw beroepen',
  'emp.etatCandidature': 'In uw sollicitaties',
  'emp.autresUn': '1 andere vacature bij {nom}',
  'emp.autresPlus': '{n} andere vacatures bij {nom}',
  'emp.chercher': 'Zoeken in deze vacatures',
  'emp.evaluer': 'Voor mij beoordelen',
  'emp.aucunResultat': 'Geen enkele vacature komt overeen.',
  'emp.autresAide': 'Buiten uw beroepen geeft Radar geen score: hij somt ze op zodat u niets ontgaat. “Voor mij beoordelen” vergelijkt een bepaalde vacature met uw cv.',
  'emp.vide': 'Momenteel geen vacatures online bij deze werkgever.',
  'emp.illisibleNuits': 'Onleesbaar sinds {n} nachten. Het team is verwittigd, u hoeft niets te doen.',
  'emp.illisibleNuit': 'Onleesbaar deze nacht. Het team is verwittigd, u hoeft niets te doen.',
  'emp.apprentissage': 'Wordt aangeleerd: antwoord voor {date}. Telt niet mee in uw {max}.',
  'emp.apprentissageDepuis': 'Wordt aangeleerd sinds {date}. Telt niet mee in uw {max}.',
  'emp.apprendLire': 'Radar leert {hote} lezen. Antwoord voor {date}.',
  'emp.apprendLireDepuis': 'Radar leert {hote} lezen sinds {date}.',
  'emp.refusee': 'Radar kan {hote} niet lezen.',
  'emp.rangeesIci': 'Intussen komen uw vacatures van {nom} die u via de extensie bewaarde hier terecht.',
  'emp.rangeesIciRefus': 'Uw vacatures van {nom} die u via de extensie bewaarde, blijven hier staan.',
  'emp.suivisTitre': 'Gevolgd',
  'emp.enAttenteTitre': 'Wordt aangeleerd · telt niet mee in uw {max}',
  'emp.enAttenteTitreSansMax': 'Wordt aangeleerd',
  'emp.annoncesTitre': 'Vacaturesites',
  'emp.annoncesAide': 'Honderden werkgevers: Radar houdt enkel uw beroepen en uw regio’s over.',
  'emp.suggeresTitre': 'Voorgesteld voor u',
  'emp.suggereUn': '1 vacature in uw beroepen',
  'emp.suggerePlus': '{n} vacatures in uw beroepen',
  'emp.luQuand': 'Gelezen {quand}',
  'emp.sousTitre': 'Radar leest hun pagina’s elke nacht opnieuw · {n} van {max} sites gevolgd',
  'emp.sousTitreSansMax': 'Radar leest hun pagina’s elke nacht opnieuw · {n} sites gevolgd',
  'pont.texte': 'U hebt {n} vacatures van {nom} bewaard via de extensie. {nom} op uw radar zetten?',
  'pont.suivre': '{nom} volgen',
  'pont.ajouter': 'Zijn vacaturepagina toevoegen',
  'pont.non': 'Nee, bedankt',
  'pont.nonToast': 'Radar stelt het u niet meer voor.',
  'entretien.titre': 'Het gesprek voorbereiden',
  'entretien.aide': 'De waarschijnlijke vragen, en wat u met uw cv kunt antwoorden.',
  'entretien.preparer': 'Voorbereiden',
  'entretien.redaction': 'Voorbereiden…',
  'entretien.refaire': 'Opnieuw',
  'entretien.aPoser': 'Te vragen',
  'entretien.aideSourcee': 'Radar zoekt het nieuws van de werkgever en hoe hij aanwerft, en bereidt daarna de waarschijnlijke vragen voor. Elke bron wordt vermeld. Ongeveer een minuut.',
  'entretien.enCours': 'Radar zoekt, ongeveer een minuut. U mag de pagina verlaten.',
  'entretien.erreur': 'De zoekopdracht is niet gelukt.',
  'entretien.actualite': 'De werkgever op dit moment',
  'entretien.deroule': 'Hoe hij aanwerft',
  'entretien.questions': 'De waarschijnlijke vragen',
  'entretien.tireeOffre': 'Uit de vacature:',
  'entretien.rapportee': 'Gemeld',
  'entretien.rienTrouve': 'Niets openbaars en recents gevonden over de werkgever.',
  'entretien.agence': 'De vacature noemt de werkgever niet. Als u hem kent, zoekt Radar over hem.',
  'entretien.employeurNom': 'Naam van de werkgever',
  'entretien.avecEmployeur': 'Zoeken over deze werkgever',
  'entretien.parcours': 'Sollicitatie verstuurd · Het traject herbekijken',
  'remu.titre': 'Verloning',
  'remu.encore': 'Nog {n} deze maand.',
  'remu.plusDEssai': 'Geen pogingen meer deze maand.',
  'remu.aVolonte': 'Naar believen met Complet.',
  'remu.avecComplet': 'Met Radar Complet.',
  'remu.comparer': 'Vergelijken',
  'remu.nonAnnonce': 'Salaris niet vermeld',
  'remu.estimer': 'Schatten',
  'remu.aide': 'Radar zoekt wat de vacature vermeldt, het sectorminimum en recente referenties, en vermeldt elke bron. Ongeveer een minuut.',
  'remu.lancer': 'Het salaris schatten',
  'remu.enCours': 'Radar zoekt, ongeveer een minuut. U mag de pagina verlaten.',
  'remu.erreur': 'De zoekopdracht is niet gelukt.',
  'remu.reessayer': 'Opnieuw proberen',
  'remu.offreDit': 'Wat de vacature zegt',
  'remu.offreMuette': 'De vacature vermeldt geen bedrag.',
  'remu.minimum': 'Het sectorminimum',
  'remu.auMoins': '{qui}: minstens {montant}',
  'remu.sousEnPartie': 'De onderkant van de vermelde vork ligt onder dit minimum.',
  'remu.sousEntierement': 'Het vermelde bedrag ligt onder dit minimum.',
  'remu.marche': 'De marktreferenties',
  'remu.fourchette': '{fourchette}, volgens {n} bronnen die overeenstemmen.',
  'remu.pasDeFourchette': 'De referenties stemmen niet genoeg overeen voor een vork.',
  'remu.aucunRepere': 'Geen betrouwbare referentie gevonden.',
  'remu.unRepere': 'Slechts één betrouwbare referentie, geen vork.',
  'remu.quatreCinquiemes': 'In 4/5: {fourchette}',
  'remu.avantages': 'De voordelen',
  'remu.aDemander': 'Te vragen',
  'remu.agence': 'De vacature noemt de werkgever niet: de referenties gelden voor het beroep.',
  'remu.source': 'Bron: {qui}',
  'remu.sourceDatee': 'Bron: {qui}, {date}',
  'remu.sourceOffre': 'de vacature',
  'remu.sources': 'Bronnen: {retenues}, {ecartees}',
  'remu.retenue1': '1 behouden',
  'remu.retenues': '{n} behouden',
  'remu.ecartee1': '1 verworpen',
  'remu.ecarteesN': '{n} verworpen',
  'remu.ecartees': 'Verworpen',
  'remu.estimeLe': 'Geschat op {date}.',
  'remu.refaire': 'Opnieuw',
  'remu.environ': 'Ongeveer {montant}',
  'remu.entre': '{a} tot {b}',
  'remu.parHeure': 'bruto per uur',
  'remu.parMois': 'bruto per maand',
  'remu.parAn': 'bruto per jaar',
  'remu.raison.page_fermee': 'pagina gesloten of verwijderd',
  'remu.raison.page_illisible': 'pagina onleesbaar',
  'remu.raison.introuvable': 'citaat niet gevonden op de pagina',
  'remu.raison.trop_ancienne': 'ouder dan 18 maanden',
  'remu.raison.domaine_ecarte': 'aggregator of kopie',
  'remu.raison.sans_extrait': 'zonder citaat',
  'remu.raison.sans_source': 'zonder adres',
  'remu.raison.chiffre_absent': 'cijfer ontbreekt in het citaat',
  'remu.raison.autre_pays': 'ander land of andere munt',
  'remu.cadre': 'Land van de functie: {pays}. Bedragen in bruto per jaar.',
  'remu.fiabiliteTitre': 'De werkgever',
  'remu.fiabilite': '{type}. Betrouwbaarheid van de openbare cijfers: {fiab}.',
  'remu.soit': '(of {montant})',
  'remu.comp.base': 'Basis',
  'remu.comp.variable': 'Variabel',
  'remu.comp.avantage': 'Voordeel',
  'remu.fiab.haute': 'hoog',
  'remu.fiab.moyenne': 'gemiddeld',
  'remu.fiab.basse': 'laag',
  'remu.fiab.inconnue': 'onbekend',
  'remu.type.grand_groupe_tech': 'Grote technologiegroep',
  'remu.type.startup_croissance': 'Groeiende start-up',
  'remu.type.startup_debut': 'Jonge start-up',
  'remu.type.entreprise_traditionnelle': 'Gevestigd bedrijf',
  'remu.type.conseil_ou_agence': 'Consultancy of bureau',
  'remu.type.pme_locale': 'Lokale kmo',
  'remu.type.commission': 'Verloning op commissie',
  'remu.type.recrutement_tiers': 'Vacature gepubliceerd door een recruiter',
  'remu.type.public': 'Openbare sector of vzw',
  'remu.type.inconnu': 'Onbekend type werkgever',
  'relance.titre': 'Een week zonder nieuws?',
  'relance.aide': 'Verstuurd op {date}. Radar stelt maar één opvolging per sollicitatie voor.',
  'relance.preparer': 'Mijn opvolgmail voorbereiden',
  'relance.redaction': 'Schrijven…',
  'relance.objet': 'Onderwerp: {sujet}',
  'relance.copier': 'Kopiëren',
  'relance.copie': 'Opvolgmail gekopieerd.',
  'relance.envoyee': 'Ik heb ze verstuurd',
  'relance.reecrire': 'Herschrijven',
  'relance.reponse': 'Ik heb een antwoord gekregen',
  'relance.reponseQuestion': 'Welk antwoord?',
  'relance.entretien': 'Een gesprek',
  'relance.refus': 'Een afwijzing',
  'relance.abandon': 'Ik laat het vallen',
  'relance.abandonQuestion': 'Deze sollicitatie laten vallen? Ze verlaat Mijn vacatures.',
  'relance.abandonOui': 'Ja, laten vallen',
  'relance.abandonToast': 'Sollicitatie uit Mijn vacatures gehaald.',
}
